












import Vue from 'vue'
import { AppModule } from '@/store/modules/app'

export default abstract class Design extends Vue {
    abstract get showToolbar(): boolean
    abstract get activeComponent():string
    abstract get allowPreview(): boolean

    get hasGiftOptions() {
        return AppModule.hasGiftOptions
    }
}
